var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermittingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.00390625,
    width: 60,
    height: 60,
    rx: 4,
    fill: "#99ACBD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 25.0101C21 25.528 21.3426 25.866 21.8801 25.866H23.2083V22.8557C23.2083 22.2255 22.6902 21.7956 22.1098 21.7956C21.5256 21.7918 21 22.218 21 22.8557V25.0101ZM23.4202 20.5039C24.1571 20.8858 24.4092 21.4266 24.4092 22.4102V38.0157C24.4092 39.3335 25.2054 40.0737 26.3279 40.0737C27.3881 40.0737 28.1386 39.3586 28.1386 38.0743V35.4547C28.1386 34.2735 28.7074 33.6369 29.9054 33.6369H39.0571V23.3934C39.0571 21.4783 38.091 20.5039 36.1927 20.5039H23.4202ZM27.9236 25.3427C27.9236 25.0503 28.1462 24.824 28.4591 24.824H35.2461C35.5507 24.824 35.7732 25.0503 35.7732 25.3427C35.7732 25.6397 35.5507 25.8744 35.2461 25.8744H28.4591C28.1462 25.8744 27.9236 25.6397 27.9236 25.3427ZM27.9236 28.6807C27.9236 28.3799 28.1462 28.1452 28.4591 28.1452H31.9645C32.2691 28.1452 32.4916 28.3799 32.4916 28.6807C32.4916 28.9693 32.2691 29.1956 31.9645 29.1956H28.4591C28.1462 29.1956 27.9236 28.9693 27.9236 28.6807ZM28.2497 40.5039H38.0425C39.7928 40.5039 40.9479 39.3086 40.9479 37.4894V35.6936C40.9479 35.1674 40.6053 34.8378 40.0678 34.8378H30.2196C29.6775 34.8378 29.3312 35.1674 29.3312 35.6936V37.7778C29.3312 38.908 29.1039 39.8299 28.2497 40.5039Z",
    fill: "#1F2647"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermittingIcon);
export default __webpack_public_path__ + "static/media/permitting-icon.197c8c32bb069a6779f9a61c85ec627e.svg";
export { ForwardRef as ReactComponent };